import type { TMessages } from '@/types/TMessages'

export const messages = {
  button: {
    collapse: 'Свернуть',
    open: 'Развернуть',
  },
} satisfies TMessages
